import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoutesElement = ({ element }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("token"); // Check if the token exists
const userRole = localStorage.getItem("role");
  useEffect(() => {
    // Refresh the page only once if the pathname is "/home/viewplan"
    const refreshed = localStorage.getItem("hasRefreshed");

    if ((location.pathname === "/home/viewplan" || location.pathname === "/admin/manage-plan") && refreshed !== "true") {
      localStorage.setItem("hasRefreshed", "true"); // Mark as refreshed
      window.location.reload(); // Trigger page reload
    }
  if (location.pathname === "/home/viewtemplate") {
    localStorage.removeItem("hasRefreshed"); // Reset the refresh flag
  }
}, [location.pathname]);
  if (!isAuthenticated) {
    // Store the current URL in localStorage

    localStorage.setItem("redirectAfterLogin", location.pathname + location.search);
    return <Navigate to='/Reg' />;
  }
  // Role-based route protection
  if (location.pathname.startsWith('/admin')) {
    if (userRole !== 'Admin') {
      return <Navigate to='/home/dashboard' />;
    }
  } else if (location.pathname.startsWith('/home')) {
    if (userRole === 'Admin') {
      return <Navigate to='/admin' />;
    }
  }

  return element;
};

export default PrivateRoutesElement;
